module.exports = __webpack_public_path__ + "static/media/cg.026fde44.svg";